import React from "react";
import SideBar from "../src/components/SideBar";
import { createRoot } from 'react-dom/client';
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
const container = document.getElementById('root');
const root = createRoot(container)
root.render(<React.StrictMode>
  <App sidebar={SideBar} />
</React.StrictMode>)


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
